import React, { useEffect, useRef, useState } from "react";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { Button, Form, Select, Spin } from "antd";

import { useNavigate } from "react-router-dom";




import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import { aadharPattern, amountPattern, bankshowkycWindow, dispatchtoast, filterOption, getLocalStorageItem, mobilePattern, panPattern } from "../../../Utils";
import CommonInput from "../../../Common/CommonInput";
import { bankDjioaccount, getaccounttype, openbankaccount } from "../../../ApiServices/Apifun";

const BankForm = ({ otp, otp_uid, account_type, mandatory }) => {

    const [accout_type, setaccout_type] = useState([]);
    const [form] = Form.useForm();
    const formref = useRef();
    const [fields, setFields] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [selectLoading, setSelectLoading] = useState(false);

    const setbankDjioaccount = (account_request_id) => {
        setLoading(true);
        const formdata = new FormData();
        formdata.append("account_request_id", account_request_id);
        formdata.append("latitude", getLocalStorageItem("latitude"));
        formdata.append("longitude", getLocalStorageItem("longitude"));

        bankDjioaccount(formdata)
            .then((res) => {
                const script1 = document.createElement("script");
                script1.src = "https://app.digio.in/sdk/v10/digio.js";
                script1.async = true;
                document.head.appendChild(script1);
                bankshowkycWindow(
                    res.data.digio_request_id,
                    res.data.mobile,
                    res.data.digio_access_token
                );
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    };

    const handleSubmit = (val) => {
        setLoading(true);
        const formdata = new FormData();
        formdata.append("otp", otp);
        formdata.append("otp_uid", otp_uid);
        formdata.append("latitude", getLocalStorageItem("latitude"));
        formdata.append("longitude", getLocalStorageItem("longitude"));
        formdata.append("account_type", account_type);
        Object.entries(val).map(([key, value]) =>
            formdata.append(key, value)
        );
        openbankaccount(formdata)
            .then((res) => {
                console.log(res);
                if (res.status) {
                    dispatchtoast(res.message)
                    setbankDjioaccount(res.data.account_request_id)
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    };

    return (
        <>

            <div className="grid grid-cols-1 md:grid-cols-2 place-items-start">
                <Spin className="w-full" spinning={isLoading}>
                    <div className="prepaid bg-white w-full rounded-3xl  shadow-normal  ">


                        <div className="p-5">
                            <p className="font-bold mt-2  text-[15px] mb-2">
                                Bank Details
                            </p>
                            <div className="selectionFields ">
                                <Form
                                    name="basic"
                                    form={form}
                                    ref={formref}
                                    onFinishFailed={(err) => console.log(err)}
                                    onFinish={(val) => handleSubmit(val)}
                                >
                                    <Form.Item
                                        name={`first_name`}
                                        label={"Enter First Name"}
                                        labelCol={{ span: 24 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter First Name!",
                                            },
                                            {
                                                whitespace: true,
                                                message: "Field cannot contain only blank spaces",
                                            },
                                        ]}
                                    >
                                        <CommonInput
                                            placeholder="Enter Your First Name"
                                            name="first_name"
                                        />
                                    </Form.Item>{" "}
                                    <Form.Item
                                        name={`last_name`}
                                        label={"Enter Last Name"}
                                        labelCol={{ span: 24 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter Last Name!",
                                            },
                                            {
                                                whitespace: true,
                                                message: "Field cannot contain only blank spaces",
                                            },
                                        ]}
                                    >
                                        <CommonInput
                                            placeholder="Enter Your Last Name"
                                            name="last_name"
                                        />
                                    </Form.Item>{" "}
                                    <Form.Item
                                        name={`mobile`}
                                        label={"Enter Mobile"}
                                        labelCol={{ span: 24 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter Mobile!",
                                            },
                                            {
                                                pattern: mobilePattern,
                                                message: 'Invalid mobile number!',

                                            },
                                            {
                                                whitespace: true,
                                                message: "Field cannot contain only blank spaces",
                                            },
                                        ]}
                                    >
                                        <CommonInput
                                            placeholder="Enter Your Mobile"
                                            name="mobile"
                                        />
                                    </Form.Item>{" "}

                                    <Form.Item
                                        name={`aadhar`}
                                        label={"Aadhar Number"}
                                        labelCol={{ span: 24 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter Aadhar Number!",
                                            },
                                            {
                                                pattern: aadharPattern,
                                                message: 'Invalid Aadhaar card number format!',
                                            }, {
                                                whitespace: true,
                                                message: "Field cannot contain only blank spaces",
                                            },
                                        ]}
                                    >
                                        <CommonInput
                                            placeholder="Enter Your Aadhar Number"
                                            name="aadhar"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name={`pan`}
                                        label={"Pan Card"}
                                        labelCol={{ span: 24 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter Pan!",
                                            }, {
                                                pattern: panPattern,
                                                message: 'Invalid PAN format!',
                                            }, {
                                                whitespace: true,
                                                message: "Field cannot contain only blank spaces",
                                            },
                                        ]}
                                    >
                                        <CommonInput
                                            placeholder="Enter Pan"
                                            name="pan"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name={`deposit_amt`}
                                        label={"Enter Amount"}
                                        labelCol={{ span: 24 }}
                                        rules={[
                                            {
                                                required: mandatory ? false : true,
                                                message: "Enter Amount!",
                                            },
                                            {
                                                whitespace: true,
                                                pattern: amountPattern,
                                                message: "Invalid Amount!",
                                            },
                                        ]}
                                    >
                                        <CommonInput
                                            placeholder="Enter Your Amount"
                                            name="deposit_amt"
                                        />
                                    </Form.Item>{" "}

                                    <Form.Item>
                                        <Button
                                            htmlType="submit"
                                            loading={isLoading}
                                            className="bg-primary mt-2 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
                                        >
                                            Submit
                                        </Button>
                                    </Form.Item>{" "}
                                </Form>
                            </div>
                        </div>
                    </div>
                </Spin>

            </div>
        </>
    );
};

export default BankForm;
